import React from 'react';
import * as Survey from "survey-react";
import "survey-react/survey.css";
import { surveyService, catalogService } from '../../api';
import "./Home.css"
import settlementsData from './settlementsData';

const Home = (props) => {
    const [governmentUnits, setGovernmentUnits] = React.useState([]);
    const [settlements, setSettlements] = React.useState(settlementsData);
    const [streets, setStreets] = React.useState([]);
    const [selectedSurvey, setSelectedSurvey] = React.useState(null);
    const surveyModelRef = React.useRef(null);

    const alphabet = "abcčćdđefghijklmnoprsštuvzž";

    const alphabetically = (first, second) => {
        let a = first.value.toLowerCase();
        let b = second.value.toLowerCase();
        // Find the first position were the strings do not match
        let position = 0;
        while (a[position] === b[position]) {
            // If both are the same don't swap
            if (!a[position] && !b[position]) return 0;
            // Otherwise the shorter one goes first
            if (!a[position]) return 1;
            if (!b[position]) return -1;
            position++;
        }
        // Then sort by the characters position
        return alphabet.indexOf(a[position]) - alphabet.indexOf(b[position]);
    }

    React.useEffect(() => {
        const fetchData = async () => {
            const responses = await Promise.all([
                surveyService.getSurvey('bjelovarsko-bilogorska'),
                catalogService.getMunicipalitiesCities().catch(err => console.error("Error while getting municipalities/cities:", err)),


            ]);

            let surveyData = responses[0];
            const municipalitiesCities = responses[1] && responses[1].length && responses[1].filter(s => s.county_name == 'VII BJELOVARSKO-BILOGORSKA').map(fs => ({ value: fs.name, text: fs.name })).sort(alphabetically) || [];

            console.log("Got settlements:", settlements)

            try {
                surveyData.data.pages[0].elements[1].choices = municipalitiesCities;
                surveyData.data.pages[0].elements[2].choices = settlements;
                surveyData.data.pages[0].elements[5].choices = municipalitiesCities;
                surveyData.data.pages[0].elements[6].choices = settlements;

                surveyData.data.pages[3].elements[7].choices = municipalitiesCities;
                surveyData.data.pages[3].elements[8].choices = settlements;

                surveyData.data.completeText = "Završi anketu";

                surveyData.data.triggers = [
                    {
                        type: "runexpression",
                        expression: "{question2} notempty",
                        runExpression: "getSettlementsFromSelectedGovernmentUnit({question2}, 'question3')"
                    },
                    {
                        type: "runexpression",
                        expression: "{question6} notempty",
                        runExpression: "getSettlementsFromSelectedGovernmentUnit({question6}, 'question7')"
                    },

                    {
                        type: "runexpression",
                        expression: "{question27} notempty",
                        runExpression: "getSettlementsFromSelectedGovernmentUnit({question27}, 'question28')"
                    },
                    {
                        type: "runexpression",
                        expression: "{question4} notempty || {question5} notempty",
                        runExpression: "changeQuestionText({question4}, 'question5','question6','question7','question8','question20','question21','question22',{question5},'question23','question24')"
                    },
                    {
                        type: "runexpression",
                        expression: "{question24} notempty",
                        runExpression: "changeOtherOptionText({question24},'question25','question26','question27','question28','question29','question30' )"
                    },
                    {
                        type: "runexpression",
                        expression: "{question5} notempty || {question24} notempty || {question25} notempty",
                        runExpression: "changeQuestionTravelingFPSOutside({question5},{question24},{question25},'question39')"
                    },
                    {
                        type: "runexpression",
                        expression: "{question5} notempty || {question24} notempty",
                        runExpression: "changeAgreementTravelingFPSOutside({question5},{question24},'question38')"
                    },
                    {
                        type: "runexpression",
                        expression: "{question5} notempty || {question24} notempty || {question25} notempty",
                        runExpression: "changeQuestionTravelingFPSOutsideNoBus({question5},{question24},{question25},'question32','question33')"
                    },
                ];

            }
            catch (error) {
                console.error("Problem while setting survey data:", error)
            }

            setSelectedSurvey(surveyData);
        }

        fetchData();
    }, [])


    React.useEffect(() => {
        if (selectedSurvey) {
            surveyModelRef.current = model;
        }

    }, selectedSurvey)

    if (!selectedSurvey) {
        return null;
    }

    if (selectedSurvey) {
        model = new Survey.Model(selectedSurvey);
        model.onValueChanged
            .add(function (sender, options) {
                if (options.question.getType() === "dropdown") {

                    if (options.name == "question3" && model.data && model.data.question2) {
                        let county_pick = options.value
                        model.data = { county_pick }
                    }
                }
            });
        surveyModelRef.current = model;
    }

    var model = new Survey.Model(selectedSurvey.data);

    const getSettlementsFromSelectedGovernmentUnit = (params) => {
        const search = params[0];
        const target = params[1];
        const filteredSettlements = settlements.filter(s => s.jls == search).map(fs => ({ value: fs.value, text: fs.value })).sort(alphabetically);
        model.getQuestionByName(target).choices = filteredSettlements;
    }
    const changeQuestionText = (params) => {
        const chosenOption = params[0];
        const target = params[1];
        const target2 = params[2];
        const target3 = params[3];
        const target4 = params[4];
        const target5 = params[5];
        const target6 = params[6];
        const target7 = params[7];
        const chosenOption2 = params[8];
        const target9 = params[9];
        const target10 = params[10];

        if (chosenOption == "učenik/učenica") {
            model.getQuestionByName(target).title = "Školujete li se na području Bjelovarsko-bilogorske županije?"
            model.getQuestionByName(target2).title = "Mjesto školovanja (grad/općina):"
            model.getQuestionByName(target3).title = "Naselje u kojem se nalazi škola:"
            model.getQuestionByName(target4).title = "Mjesto školovanja (grad/općina, naselje):"
            model.getQuestionByName(target5).title = "Način putovanja - škola:"
            model.getQuestionByName(target6).title = "Učestalost putovanja - škola:"
            model.getQuestionByName(target7).title = "Odaberite kojim sustavom/sustavima javnog autobusnog prijevoza putnika putujete u svrhu odlaska u školu:"
            if (chosenOption2 == "da") {
                model.getQuestionByName(target9).title = "Biste li, u slučaju kvalitetnog unaprjeđenja postojećeg županijskog autobusnog prijevoza putnika na području Bjelovarsko-bilogorske županije (učestala, pouzdana i atraktivna prijevozna ponuda) postojeći način putovanja u školu potencijalno zamijenili kvalitetnim javnim županijskim prijevozom putnika?"
            }
            else if (chosenOption2 == "ne") {
                model.getQuestionByName(target9).title = "Biste li, u slučaju kvalitetnog unaprjeđenja postojećeg autobusnog prijevoza putnika (učestala, pouzdana i atraktivna prijevozna ponuda) postojeći način putovanja u školu potencijalno zamijenili kvalitetnim javnim autobusnim prijevozom putnika?"
            }
            model.getQuestionByName(target10).title = "Koje je (uz odlazak u školu) Vaše najučestalije putovanje na području Bjelovarsko-bilogorske županije?"
        }
        else if (chosenOption == "student/studentica") {
            model.getQuestionByName(target).title = "Studirate li na području Bjelovarsko-bilogorske županije?"
            model.getQuestionByName(target2).title = "Mjesto studiranja (grad/općina):"
            model.getQuestionByName(target3).title = "Naselje u kojem se nalazi fakultet:"
            model.getQuestionByName(target4).title = "Mjesto studiranja (grad/općina, naselje):"
            model.getQuestionByName(target5).title = "Način putovanja - fakultet:"
            model.getQuestionByName(target6).title = "Učestalost putovanja - fakultet:"
            model.getQuestionByName(target7).title = "Odaberite kojim sustavom/sustavima javnog autobusnog prijevoza putnika putujete u svrhu odlaska na fakultet:"
            if (chosenOption2 == "da") {
                model.getQuestionByName(target9).title = "Biste li, u slučaju kvalitetnog unaprjeđenja postojećeg županijskog autobusnog prijevoza putnika na području Bjelovarsko-bilogorske županije (učestala, pouzdana i atraktivna prijevozna ponuda) postojeći način putovanja na fakultet potencijalno zamijenili kvalitetnim javnim županijskim prijevozom putnika?"
            }
            else if (chosenOption2 == "ne") {
                model.getQuestionByName(target9).title = "Biste li, u slučaju kvalitetnog unaprjeđenja postojećeg autobusnog prijevoza putnika (učestala, pouzdana i atraktivna prijevozna ponuda) postojeći način putovanja na fakultet potencijalno zamijenili kvalitetnim javnim autobusnim prijevozom putnika?"
            }
            model.getQuestionByName(target10).title = "Koje je (uz odlazak na fakultet) Vaše najučestalije putovanje na području Bjelovarsko-bilogorske županije?"
        }
        else if (chosenOption == "zaposlena osoba") {
            model.getQuestionByName(target).title = "Nalazi li se Vaše mjesto zaposlenja na području Bjelovarsko-bilogorske županije?"
            model.getQuestionByName(target2).title = "Mjesto zaposlenja (grad/općina):"
            model.getQuestionByName(target3).title = "Naselje mjesta zaposlenja:"
            model.getQuestionByName(target4).title = "Mjesto zaposlenja (grad/općina, naselje):"
            model.getQuestionByName(target5).title = "Način putovanja - posao:"
            model.getQuestionByName(target6).title = "Učestalost putovanja - posao:"
            model.getQuestionByName(target7).title = "Odaberite kojim sustavom/sustavima javnog autobusnog prijevoza putnika putujete u svrhu odlaska na posao:"
            if (chosenOption2 == "da") {
                model.getQuestionByName(target9).title = "Biste li, u slučaju kvalitetnog unaprjeđenja postojećeg županijskog autobusnog prijevoza putnika na području Bjelovarsko-bilogorske županije (učestala, pouzdana i atraktivna prijevozna ponuda) postojeći način putovanja na posao potencijalno zamijenili kvalitetnim javnim županijskim prijevozom putnika?"
            }
            else if (chosenOption2 == "ne") {
                model.getQuestionByName(target9).title = "Biste li, u slučaju kvalitetnog unaprjeđenja postojećeg autobusnog prijevoza putnika (učestala, pouzdana i atraktivna prijevozna ponuda) postojeći način putovanja na posao potencijalno zamijenili kvalitetnim javnim autobusnim prijevozom?:"
            }
            model.getQuestionByName(target10).title = "Koje je (uz odlazak na posao) Vaše najučestalije putovanje na području Bjelovarsko-bilogorske županije?"
        }
        else if (chosenOption == "nezaposlena osoba") {
            model.getQuestionByName(target10).title = "Koje je Vaše najučestalije putovanje na području Bjelovarsko-bilogorske županije?"
        }
        else if (chosenOption == "umirovljenik/umirovljenica") {
            model.getQuestionByName(target10).title = "Koje je Vaše najučestalije putovanje na području Bjelovarsko-bilogorske županije?"
        }
    }

    const changeOtherOptionText = (params) => {
        const chosenOption = params[0];
        const target1 = params[1];
        const target2 = params[2];
        const target3 = params[3];
        const target4 = params[4];
        const target5 = params[5];
        const target6 = params[6];
        if (chosenOption != "odlazak u kupovinu" && chosenOption != "odlazak na tržnicu/sajam" && chosenOption != "odlazak k liječniku" && chosenOption != "obavljanje administrativnih aktivnosti (pošta, banka, FINA,…)" &&
            chosenOption != "odlazak na sportsko-rekreativne aktivnosti ili priredbe" && chosenOption != "odlazak na glazbeno-kulturne aktivnosti ili priredbe" &&
            chosenOption != "odlazak u ugostiteljske objekte" && chosenOption != "odlazak u posjetu") {
            model.getQuestionByName(target1).title = "Način putovanja - prethodno navedena svrha putovanja:"
            model.getQuestionByName(target2).title = "Učestalost putovanja - prethodno navedena svrha putovanja:"
            model.getQuestionByName(target3).title = "Mjesto prethodno navedene svrhe putovanja (grad/općina):"
            model.getQuestionByName(target4).title = "Naselje prethodno navedene svrhe putovanja (grad/općina):"
            model.getQuestionByName(target5).title = "Odaberite kojim sustavom/sustavima javnog autobusnog prijevoza putnika putujete u prethodno navedenu svrhu:"
            model.getQuestionByName(target6).title = "Biste li, u slučaju kvalitetnog unaprjeđenja postojećeg županijskog autobusnog prijevoza putnika na području Bjelovarsko-bilogorske županije (učestala, pouzdana i atraktivna prijevozna ponuda) postojeći način putovanja u prethodno navedenu svrhu potencijalno zamijenili kvalitetnim javnim županijskim prijevozom putnika?"
        }
        else if (chosenOption != "ne putujem često") {
            model.getQuestionByName(target1).title = "Način putovanja -  {question24}:"
            model.getQuestionByName(target2).title = "Učestalost putovanja - {question24}:"
            model.getQuestionByName(target3).title = "Mjesto putovanja (grad/općina) - {question24}:"
            model.getQuestionByName(target4).title = "Naselje putovanja  - {question24}:"
            model.getQuestionByName(target5).title = "Odaberite kojim sustavom/sustavima javnog autobusnog prijevoza putnika putujete - {question24}:"
            model.getQuestionByName(target6).title = "Biste li, u slučaju kvalitetnog unaprjeđenja postojećeg županijskog autobusnog prijevoza putnika na području Bjelovarsko-bilogorske županije (učestala, pouzdana i atraktivna prijevozna ponuda) postojeći način putovanja - {question24} potencijalno zamijenili kvalitetnim javnim županijskim prijevozom putnika?"

        }
    }

    const changeQuestionTravelingFPSOutside = (params) => {
        const chosenOption1 = params[0];
        const chosenOption2 = params[1];
        const chosenOption3 = params[2];
        const target = params[3];
        if (chosenOption1 == "ne") {
            if (chosenOption2 == "ne putujem često" || chosenOption3 == "autobus") {
                model.getQuestionByName(target).title = "Molimo odaberite tri najvažnija razloga zbog kojih Vam javni prijevoz putnika autobusom nije prihvatljiv:"
                }    
            else{
                model.getQuestionByName(target).title = "Molimo odaberite tri najvažnija razloga zbog kojih Vam javni županijski prijevoz putnika autobusom na području Bjelovarsko-bilogorske županije nije prihvatljiv:"
               }
        }
        else{
            model.getQuestionByName(target).title = "Molimo odaberite tri najvažnija razloga zbog kojih Vam javni županijski prijevoz putnika autobusom na području Bjelovarsko-bilogorske županije nije prihvatljiv:"
            }
    }
    const changeAgreementTravelingFPSOutside = (params) => {
        const chosenOption1 = params[0];
        const chosenOption2 = params[1];
        const target = params[2];
        if (chosenOption1 == "ne") {
            if (chosenOption2 == "ne putujem često") {
                 model.getQuestionByName(target).title = "Ocijenite razinu motiviranosti za promjenom Vašeg postojećeg/postojećih načina putovanja autobusnim prijevozom putnika:"
            }
            else{
                model.getQuestionByName(target).title = "Ocijenite razinu motiviranosti za promjenom Vašeg postojećeg/postojećih načina putovanja županijskim prijevozom putnika autobusom:"
            }
        }
        else{
            model.getQuestionByName(target).title = "Ocijenite razinu motiviranosti za promjenom Vašeg postojećeg/postojećih načina putovanja županijskim prijevozom putnika autobusom:"
        }
    }

    const changeQuestionTravelingFPSOutsideNoBus = (params) => {
        const chosenOption1 = params[0];
        const chosenOption2 = params[1];
        const chosenOption3 = params[2];
        const target1 = params[3];
        const target2= params[4];
        if (chosenOption1 == "ne") {
            if (chosenOption2 == "ne putujem često" || chosenOption3 != "autobus") {
                model.getQuestionByName(target1).title = "Molimo odaberite najvažnije razloge korištenja sustava javnog autobusnog prijevoza putnika:"
                model.getQuestionByName(target2).title = "Molimo odaberite tri najveća izazova pri aktivnom korištenju sustava javnog autobusnog prijevoza putnika:"
            }
            else{
                model.getQuestionByName(target1).title = "Molimo odaberite najvažnije razloge korištenja sustava javnog prijevoza putnika autobusom na području Bjelovarsko-bilogorske županije:"
                model.getQuestionByName(target2).title = "Molimo odaberite tri najveća izazova pri aktivnom korištenju sustava javnog prijevoza putnika autobusom na području Bjelovarsko-bilogorske županije:"
            }
        }
        else{
            model.getQuestionByName(target1).title = "Molimo odaberite najvažnije razloge korištenja sustava javnog prijevoza putnika autobusom na području Bjelovarsko-bilogorske županije:"
            model.getQuestionByName(target2).title = "Molimo odaberite tri najveća izazova pri aktivnom korištenju sustava javnog prijevoza putnika autobusom na području Bjelovarsko-bilogorske županije:"
            }
    }
    const onComplete = async (survey, options) => {
        //Write survey results into database
        await surveyService.createSurveyResponse({ surveyId: selectedSurvey.surveyId, payload: survey.data });
    }

    Survey.FunctionFactory.Instance.register("getSettlementsFromSelectedGovernmentUnit", getSettlementsFromSelectedGovernmentUnit);
    Survey.FunctionFactory.Instance.register("changeQuestionText", changeQuestionText);
    Survey.FunctionFactory.Instance.register("changeOtherOptionText", changeOtherOptionText);
    Survey.FunctionFactory.Instance.register("changeQuestionTravelingFPSOutside", changeQuestionTravelingFPSOutside);
    Survey.FunctionFactory.Instance.register("changeAgreementTravelingFPSOutside", changeAgreementTravelingFPSOutside);
    Survey.FunctionFactory.Instance.register("changeQuestionTravelingFPSOutsideNoBus", changeQuestionTravelingFPSOutsideNoBus);
    Survey.locale = "hr";
    return (
        <Survey.Survey model={model} locale="hr" onComplete={onComplete} />
    )
}

export default Home;